<template>
  <div id="paginaOrdini">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Elenco Ordini</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id="dropAnniRiferimento" ref="dropAnniRiferimento" :query="queryAnno"
                  :dataSource="annoRiferimentoList" :index="annoIndex" :fields="annoRiferimentoFields"
                  :change="onAnnoRiferimentoChange" v-model="annoRiferimentoCorrente"
                  placeholder="Seleziona un Anno"></ejs-dropdownlist>
              </b-col>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                  @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-alert variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown" height="4px" />
                </b-alert>
              </b-col>

              <b-col xl="12" md="12" class="pt-1">
                <ejs-grid id="gridA" ref="gridA" :dataSource="ordiniFullData" :allowSorting="true"
                  :sortSettings="gridA.sortOptions" :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions"
                  :height="gridA.height" :allowFiltering="true" :filterSettings="gridA.filterOptions"
                  :editSettings="gridA.editOptions">
                  <e-columns>
                    <e-column field="id" headerText="ID" :isPrimaryKey="true" width="30"></e-column>
                    <e-column field="data" headerText="Data" :format="settings.formatoData" type="date"
                      width="30"></e-column>
                    <e-column field="protocollo" headerText="Protocollo" width="40"></e-column>
                    <e-column field="intestatario" headerText="Intestatario" width="40"></e-column>
                    <e-column field="titolo" headerText="Titolo" width="30"></e-column>
                    <e-column field="descrizione" headerText="Descrizione" width="30"></e-column>
                    <e-column field="tipo_pagamento" headerText="Tipo Pagamento" width="30"></e-column>
                    <e-column field="totale" headerText="Totale" width="60"></e-column>
                  </e-columns>
                </ejs-grid>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- dialogA: dialogDettaglioOrdine ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog id="dialogA" ref="dialogA" :header="dialogA.header" :buttons="dialogA.buttons" :visible="dialogA.visible"
      :showCloseIcon="dialogA.showCloseIcon" :close="dialogAClose" :open="dialogAOpen" :zIndex="dialogA.zIndex"
      :animationSettings="dialogA.animationSettings" :isModal="dialogA.isModal">
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA" v-model="dialogA.tabAdialogAIndex">
        <b-tab title="Dati Ordine">
          <b-row class="match-height">
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dati Ordine</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="id" class="h5">Id</label>
                      <ejs-textbox id="id" v-model="ordiniActiveData.id" floatLabelType="Never" cssClass=""
                        placeholder="id" showClearButton="true" type="text" autocomplete="false" :readonly="true" />
                    </b-col>

                    <b-col xl="6" md="6" class="mb-2">
                      <label for="data" class="h5">Data</label>
                      <ejs-datepicker id="data" v-model="ordiniActiveData.data"
                                      :format="settings.formatoDatepicker" placeholder="Data"
                                      :firstDayOfWeek="settings.firstDayOfWeek"/>
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="cig" class="h5">Codice Identificativo Gara</label>
                      <ejs-textbox id="cig" v-model="ordiniActiveData.cig" floatLabelType="Never" cssClass=""
                                   showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="tipologia" class="h5">Tipologia</label>
                      <ejs-textbox id="titolo" v-model="ordiniActiveData.tipologia" floatLabelType="Never" cssClass=""
                                   showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="intestatario" class="h5">Intestatario</label>
                      <ejs-textbox id="intestatario" v-model="ordiniActiveData.intestatario" placeholder="Intestatario" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="titolo" class="h5">Titolo</label>
                      <ejs-textbox id="titolo" v-model="ordiniActiveData.titolo" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="sottotitolo" class="h5">Sottotitolo</label>
                      <ejs-textbox id="sottotitolo" v-model="ordiniActiveData.sottotitolo" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="dropSpettacoli" class="h5">Spettacolo</label>
                      <ejs-dropdownlist
                        id="dropSpettacoli"
                        ref="dropSpettacoli"
                        :query="querySpettacoli"
                        :dataSource="spettacoliFullData"
                        :index="spettacoliIndex"
                        :fields="elencoSpettacoliFields"
                        v-model="ordiniActiveData.spettacolo"
                        placeholder="Seleziona uno Spettacolo"
                        :allowFiltering="true"
                        :filtering="spettacoloFiltering"
                      ></ejs-dropdownlist>
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="fornitore" class="h5">Fornitore</label>
                      <ejs-dropdownlist
                        id="fornitore" ref="fornitore"
                        v-model="ordiniActiveData.fornitore"
                        :dataSource="fornitoriList" :fields="fornitoriFields"
                        :allowFiltering="true" :filtering="fornitoriFiltering"
                        :itemTemplate="itemTemplate" :valueTemplate="valueTemplate"
                        placeholder="Scegli fornitore"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="descrizione" class="h5">Descrizione</label>
                      <ejs-textbox id="descrizione" v-model="ordiniActiveData.descrizione" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="tipo_pagamento" class="h5">Modalita' pagamento</label>
                      <ejs-textbox id="tipo_pagamento" v-model="ordiniActiveData.tipo_pagamento" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>

                    <b-col xl="12" md="12" class="pt-1">
                      <ejs-grid id="gridD" ref="gridD" :dataSource="elementiOrdineFullData" :allowSorting="true"
                        :toolbar="gridD.toolbarOptions" :height="gridD.height" :toolbarClick="gridDClickHandler"
                        :allowFiltering="true" :filterSettings="gridD.filterOptions" :editSettings="gridD.editOptions"
                       >
                        <e-columns>
                          <e-column field="id" headerText="ID" :isPrimaryKey="true" width="30" :visible="false"></e-column>
                          <e-column field="qta" headerText="Q.ta" width="30"></e-column>
                          <e-column field="unita_misura" headerText="Unita' misura" width="30"></e-column>
                          <e-column field="codice" headerText="Codice" width="40"></e-column>
                          <e-column field="descrizione" headerText="Descrizione" width="100"></e-column>
                          <e-column field="costo_singolo" headerText="Costo Singolo" width="100"></e-column>
                          <e-column field="costo_totale" headerText="Costo Totale" width="100"></e-column>
                        </e-columns>
                        <e-aggregates>
                          <e-aggregate>
                            <e-columns>
                              <e-column type="Sum" field="costo_totale" format="€ ######.##" ></e-column>
                            </e-columns>
                          </e-aggregate>
                        </e-aggregates>
                      </ejs-grid>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>

    <ejs-dialog
      id="dialogB"
      ref="dialogB"
      :header="dialogB.header"
      :buttons="dialogB.buttons"
      :visible="dialogB.visible"
      :showCloseIcon="dialogB.showCloseIcon"
      :close="dialogBClose"
      :open="dialogBOpen"
      :zIndex="dialogB.zIndex"
      :animationSettings="dialogB.animationSettings"
      :height="dialogB.height"
      :width="dialogB.width"
      :isModal="dialogB.isModal"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogB" v-model="dialogB.tabAdialogBIndex">
        <b-tab title="Dettaglio elemento">
          <b-row class="match-height">
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Elemento Ordine</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body DDD -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="qta" class="h5">Quantita</label>
                      <ejs-numerictextbox
                        id="qta" v-model="elementiOrdineActiveData.qta"
                        floatLabelType="Never" cssClass="" placeholder="Qta"
                        showSpinButton="false" showClearButton="true"
                        format="n2" :decimals="2" :min="0"
                        :change="onQtaChange"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="unita_misura" class="h5">Unita' di misura</label>
                      <ejs-textbox id="unita_misura" v-model="elementiOrdineActiveData.unita_misura" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false" />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="codice" class="h5">Codice</label>
                      <ejs-textbox id="codice" v-model="elementiOrdineActiveData.codice" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false" />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="descrizione" class="h5">Descrizione</label>
                      <ejs-textbox id="descrizione" v-model="elementiOrdineActiveData.descrizione" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false" />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="costo_singolo" class="h5">Costo singolo</label>
                      <ejs-numerictextbox
                        id="costo_singolo" v-model="elementiOrdineActiveData.costo_singolo"
                        floatLabelType="Never" cssClass="" format="€ #,##0.00" :decimals="2" showSpinButton="false" showClearButton="true"
                        :change="onCostoSingoloChange"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="costo_totale" class="h5">Costo totale</label>
                      <ejs-numerictextbox
                        id="costo_totale" v-model="elementiOrdineActiveData.costo_totale"
                        floatLabelType="Never" cssClass="" format="€ #,##0.00" :decimals="2" showSpinButton="false" showClearButton="true"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  ImagePlugin,
  LinkPlugin,
  AlertPlugin,
  ToastPlugin,
} from "bootstrap-vue";
// import Vuexy

// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import {
  DateTimePickerPlugin,
  DateRangePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
  Aggregate,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(ImagePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api

const apiFornitoriUrl = "/demo/api/soggetto/fornitori";
const apiSpettacoliRicercaUrl = "/demo/api/spettacolo/ricerca";
const apiOrdiniUrl = "/demo/api/ordine";
const apiOrdiniGeneraUrl = "/demo/api/ordine/genera";
const apiOrdiniAnnoUrl = "/demo/api/ordine/anno";
const apiElementiOrdineCreateUrl = "/demo/api/elementoordine/bulk_create";
const apiElementoOrdineCreateSingoloUrl = "/demo/api/elementoordine";
const apiElementiOrdineUrl = "/demo/api/elementoordine";

var itemVue = Vue.component("itemTemplate", {
  template: `<span><span class='ragioneSociale'>{{data.ragioneSociale}}</span><span style='margin-right:3em;display:inline-block;'>&nbsp;&nbsp;</span><span class ='partitaIva'>{{data.partitaIva}}</span></span>`,
  data() {
    return {
      data: {},
    };
  },
});

export default Vue.extend({
  components: {},
  data() {
    return {
      dataOggi: new Date(),
      // tmp
      nonMostrare: false, // utile per non cancellare codice in editing
      // generali
      settings: {
        formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
        formatoOra: { skeleton: "Hm" },
        //formatoOra: 'HH:mm',
        formatoOraGrid: { type: "dateTime", format: "HH:mm" }, // da usare per grid
        formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
        intervalloOra: 5,
        firstDayOfWeek: 1,
      },
      ordiniFullData: [],
      ordiniActiveId: 0,
      ordiniActiveData: {},
      elementiOrdineFullData: [],
      elementiOrdineActiveData: {},
      elementiOrdineActiveId: 0,

      // per inizializzazione dropdown a null
      initIndex: -1,
      //fornitori
      fornitoriList: [],
      fornitoriFields: { text: "ragioneSociale", value: "id" },
      //spettacoli
      spettacoliFullData: [],
      elencoSpettacoliFields: { value: "id", text: "titolo" },
      spettacoliIndex: -1,
      // tipo pagamento
      tipoList: [
        { label: "Bonifico", val: "bonifico" },
        { label: "Emolumento", val: "emolumento" },
      ],
      tipoFields: { text: "label", value: "val" },

      itemTemplate: function () {
        return { template: itemVue };
      },
      valueTemplate: function () {
        return { template: itemVue };
      },

      annoRiferimentoList: [
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      annoRiferimentoFields: { value: "val", text: "label" },
      annoIndex: -1,
      queryAnno: null,
      querySpettacoli: null,
      annoRiferimentoCorrente: "2025",
      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA
      dialogA: {
        header: "",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogAOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogACancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogAIndex: 0,
        isModal: false,
      },

      // per dialog B
      dialogB: {
        header: "Elemento ordine",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogBOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogBCancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1060,
        tabAdialogBIndex: 0,
        height: "90%",
        width: "90%",
        isModal: true,
      },

      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuovo Ordine",
            tooltipText: "Crea nuovo ordine",
            prefixIcon: "e-plus",
            id: "new",
          },
          {
            text: "Modifica",
            tooltipText: "Modifica ordine",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Cancella",
            tooltipText: "Cancella ordine",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          {
            text: "Download",
            tooltipText: "Download",
            prefixIcon: "e-save",
            id: "download",
          },
          "Search",
        ],
        sortOptions: { columns: [{ field: "data", direction: "Ascending" }] },
      },
      // per gridD
      gridDFlag: false,
      gridD: {
        height: 300,
        editOptions: {
          allowEditing: true,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuovo elemento",
            tooltipText: "Aggiungi nuovo elemento",
            prefixIcon: "e-plus",
            id: "new",
          },
          {
            text: "Modifica",
            tooltipText: "Modifica elemento",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Cancella",
            tooltipText: "Cancella elemento",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          "Search",
        ],
      },
    };
  },
  created() {
    console.log("Pagina Ordini Creata");
    // inizializzazione elenchi dal backend
    // chiamate API
    this.annoRiferimentoCorrente = this.dataOggi.getFullYear().toString()

    if (localStorage.getItem("userData") !== null) {
      console.log("Recupero elenco Ordini dal backend");
      // fornitori
      useJwt.get(apiFornitoriUrl).then((d) => {
        if (d.status != 200) {
          console.log("REDIRIGERE A LOGIN");
          alert("Effettua di nuovo il login");
        } else {
          // console.log(d.status);
          // console.log(d.data);
          this.fornitoriList = d.data;
        }
      });

      const datiDaInviare = { anno: this.annoRiferimentoCorrente, };
      useJwt.post(apiOrdiniAnnoUrl, datiDaInviare).then((d) => {
        console.log("Ordini")
        console.log(d.data);
        this.ordiniFullData = d.data;
      });
      // recupera spettacoli anno

      const stagioneSpettacolo = { stagione: this.annoRiferimentoCorrente, };
      useJwt.post(apiSpettacoliRicercaUrl, stagioneSpettacolo).then((d) => {
        console.log("SPETTACOLI");
        console.log(d.data);
        this.spettacoliFullData = d.data;
      });
    } else {
      console.log("Non trovo UserData, prova ancora");
    }
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey, Aggregate],
    // per multiselect
    multiselect: [CheckBoxSelection],
  },
  methods: {
    fornitoriFiltering: function (e) {
      var searchData = this.fornitoriList;
      var query = new Query();
      query = e.text != "" ? query.where("ragioneSociale", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },
    spettacoloFiltering: function (e) {
      var searchData = this.spettacoliFullData;
      var query = new Query();
      query =
        e.text != "" ? query.where("titolo", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },
    onAnnoRiferimentoChange: function (e) {
      console.log("Change")
      console.log("Recupero elenco ordini per l'anno selezionato");
      const datiDaInviare = { anno: this.annoRiferimentoCorrente, };
      useJwt.post(apiOrdiniAnnoUrl, datiDaInviare).then((d) => {
        console.log("Ordini")
        console.log(d.data);
        this.ordiniFullData = d.data;
      });
      const stagioneSpettacolo = { stagione: this.annoRiferimentoCorrente, };
      useJwt.post(apiSpettacoliRicercaUrl, stagioneSpettacolo).then((d) => {
        console.log("SPETTACOLI");
        console.log(d.data);
        this.spettacoliFullData = d.data;
      });
    },

    onCostoSingoloChange: function (e) {
      // arrotondo a 2 decimali così il valore è già pronto per l'invio
      // (costo_totale lato backend ammette al massimo 2 decimali)
      this.elementiOrdineActiveData.costo_totale = Number((this.elementiOrdineActiveData.costo_singolo * this.elementiOrdineActiveData.qta).toFixed(2))
    },
    onQtaChange: function (e) {
      // arrotondo a 2 decimali così il valore è già pronto per l'invio
      // (costo_totale lato backend ammette al massimo 2 decimali)
      this.elementiOrdineActiveData.costo_totale = Number((this.elementiOrdineActiveData.costo_singolo * this.elementiOrdineActiveData.qta).toFixed(2))
    },
    onFornitoreChange: function (e) {
      console.log("Cambio fornitore")
      console.log(this.$refs.fornitore.ej2Instances.value)
      const id_fornitore = this.$refs.fornitore.ej2Instances.value
      // adesso devo cercare nella lista fornitori per ID
      // filter 

      const i = this.fornitoriList.findIndex((x) => x.id === id_fornitore)
      if (i >= 0) {
        const t = this.fornitoriList[i] // ho il fornitore
        this.elementiOrdineActiveData.ragioneSociale = t.ragioneSociale
        if(t.banca1IBAN)
          this.elementiOrdineActiveData.iban = t.banca1IBAN
        else
          this.elementiOrdineActiveData.iban = t.banca2IBAN
        console.log(this.elementiOrdineActiveData)
      } else {
        console.log("non trovato")
      }
    },
    // per dialogA
    dialogAOpen(args) {
      console.log("Apertura dialogA");
    
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogAClose() {
      console.log("Chiusura dialogA");
      this.dialogA.tabAdialogAIndex = 0;
      //console.log(this.ordiniActiveData);
    },
    // applica l'esito del bulk_create degli elementiOrdine:
    // - assegna gli id reali alle righe salvate (per indice originale)
    // - restituisce il messaggio di errore composto evidenziando riga ed errore
    //   (vuoto se non ci sono errori)
    applicaEsitoElementiOrdine(data) {
      // assegno gli id reali alle righe salvate, usando l'indice originale
      if (data.salvati) {
        data.salvati.forEach((s) => {
          if (this.elementiOrdineFullData[s.indice]) {
            this.elementiOrdineFullData[s.indice].id = s.id
          }
        })
      }
      let messaggio = ""
      if (data.errori) {
        // evidenzio quale riga è in errore e il relativo messaggio
        data.errori.forEach((e) => {
          Object.keys(e.errori).forEach((k) => {
            messaggio += `riga ${e.indice + 1} — ${k}: ${e.errori[k]}`
            messaggio += "\n"
          })
        })
      }
      this.elementiOrdineFullData = [...this.elementiOrdineFullData]
      return messaggio
    },
    async dialogAOk() {
      let error = false
      console.log("Cliccato bottone OK di dialogA");
      // salvataggio informazioni in remoto
      if (this.ordiniActiveId === 0) {
        // salvataggio in caso di new
        error = await useJwt.post(apiOrdiniUrl, this.ordiniActiveData)
          .then((res) => {
            this.ordiniActiveId = res.data.id;
            // allineo anche l'id nei dati: se il dialog resta aperto (es. elementi
            // non validi) un successivo OK fa PATCH e il backend cerca l'ordine
            // tramite l'id presente nel body
            this.ordiniActiveData.id = res.data.id;
            return this; // restituisci contesto per permettere aggiornamento grid
          })
          .then((context) => {
            // faccio post di tutti gli elementi e li salvo uno ad uno lato server
            const datiDaInviare = {
              'ordine_id': this.ordiniActiveId,
              'elementi': this.elementiOrdineFullData,
            }
            console.log("elementi ordine")
            console.log(datiDaInviare)
            // ritorno la promise per propagare eventuali errori al catch esterno
            return useJwt.post(apiElementiOrdineCreateUrl, datiDaInviare).then((res) => {
              if (res.status == 200 || res.status == 201) {
                console.log(res.data)
                // assegno gli id reali alle righe salvate
                this.applicaEsitoElementiOrdine(res.data)
              }
              return context
            });
          })
          .then((context) => {
            const datiDaInviare = { anno: context.annoRiferimentoCorrente, };
            useJwt.post(apiOrdiniAnnoUrl, datiDaInviare).then((res) => {
              console.log("Aggiornamento gridA dopo aggiunta ordine");
              context.ordiniFullData = res.data;
              context.ordiniFullData = [...context.ordiniFullData];
              console.log(context.ordiniFullData)
            })
            
            return false
          }).catch(err => {
            let messaggio = ""
            if (err.response) {
              const data = err.response.data
              if (data.errori) {
                // errore di validazione su uno o più elementiOrdine:
                // assegno gli id ai salvati, rimuovo dalla grid i non validi
                // e compongo il messaggio
                messaggio = this.applicaEsitoElementiOrdine(data)
              } else {
                // errore sull'ordine stesso (formato piatto)
                Object.keys(data).forEach((k) => {
                  messaggio += `${k}: ${data[k]}`
                  messaggio += "\n"
                })
              }
              console.log(messaggio)
              this.makeToast("primary", "ERRORE", messaggio);
            }
            return true
          })
          if (!error) {
            // nascondi dialog solo se creazione avvenuta con successo
            this.$refs.dialogA.hide();
          }

      } else {
        // salvataggio in caso di edit
        const editUrl = `${apiOrdiniUrl}/${this.ordiniActiveId}`;

        error = await useJwt.patch(editUrl, this.ordiniActiveData)
          .then((res) => {
            console.log("salvataggio ordine OK")
            return this
          }).then((context) => {
              const datiDaInviare = { anno: context.annoRiferimentoCorrente, };
              useJwt.post(apiOrdiniAnnoUrl, datiDaInviare).then((d) => {
                console.log("Ordini")
                console.log(d.data);
                context.ordiniFullData = d.data;
              });
              return false
            }).catch(error => {
            let messaggio = ""
            if (error.response) {
              console.log(error.response.data)
              let chiavi = Object.keys(error.response.data)
              chiavi.forEach((k) => {
                messaggio += `${k}: ${error.response.data[k]}`
                messaggio += "\n"
              })
              console.log(messaggio)
              this.makeToast("primary", "ERRORE", messaggio);
            }
            return true
          })
          if (!error) {
            this.$refs.dialogA.hide();
          }
      }
    },
    dialogACancel() {
      console.log("Cliccato bottone Cancel di dialogA");
      this.$refs.dialogA.hide();
    },
    // per gridA
    gridAClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "new") {
        this.dialogA.header = "Nuovo Ordine"
        const oggi = new Date
        this.ordiniDefaultData = {
          id: 0,
          data: oggi,
          intestatario: null,
          titolo: null,
          sottotitolo: null,
          spettacolo: null,
          fornitore: null,
          descrizione: null,
          tipo_pagamento: null,
          tipologia: "Ordine",
        }
        this.ordiniActiveData = this.ordiniDefaultData
        console.log("Premuto pulsante creazione nuovo ordine da gridA")
        // console.log(this.ordiniActiveData);
        // console.log(this.praticheVVFDefaultData);
        this.ordiniActiveId = 0
        this.elementiOrdineFullData = []
        this.$refs.dialogA.show(true)
      }
      else if (args.item.id === "edit") {
        console.log("Premuto pulsante modifica ordine da gridA");
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          this.ordiniActiveId = selectedRow[0].id
          console.log("gridA, Id selezionato:")
          console.log(this.ordiniActiveId)
          const i = this.ordiniFullData.findIndex(
            (x) => x.id === this.ordiniActiveId
          )
          if (i >= 0) {
            this.ordiniActiveData = this.ordiniFullData[i]
            this.elementiOrdineFullData = this.ordiniActiveData.elementi
            console.log(this.ordiniActiveData)

            // TODO: qualielementi da riassociare? Fornitore e spettacolo?
            this.elementiOrdineFullData.forEach((obj) => {
              const j = this.fornitoriList.findIndex((x) => x.id === obj.fornitore)
              if (j >= 0) {
                const t = this.fornitoriList[j] // ho il fornitore
                obj.ragioneSociale = t.ragioneSociale
              }
            })
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella")
          console.log(err)
          this.alertAShow()
        }

        this.$refs.dialogA.show(true)
      } else if (args.item.id === "delete") {
        try {
            console.log("Premuto pulsante elimina elemento ordine da gridA")
            const selectedRow = this.$refs.gridA.getSelectedRecords()
            const deletedElementId = selectedRow[0].id
            const deleteUrl = `${apiOrdiniUrl}/${deletedElementId}`
            this.$refs.gridA.ej2Instances.deleteRecord()
            useJwt.delete(deleteUrl).then((res) => {
                console.log("Eliminazione avvenuta con successo")
                // console.log(res.data)
            })
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === "download") {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          const datiDaInviare = {'id': selectedRow[0].id, 'stagione': this.annoRiferimentoCorrente}
          useJwt.post(apiOrdiniGeneraUrl, datiDaInviare).then((d) => {
            console.log(d.data)

            const nomeFile = d.data['fileDocumento'].split('\\').pop().split('/').pop().split('?')[0]

            const link = document.createElement("a");
            link.href = d.data['fileDocumento']
            link.setAttribute("download", nomeFile);
            document.body.appendChild(link);
            link.click();
          })
      }
    },
    // per dialogB
    dialogBOpen(args) {
      if (this.elementiOrdineActiveId == 0) {
        this.elementiOrdineActiveData = {
          'qta': 0,
          'unita_misura': '',
          'codice': '',
          'descrizione': '',
          'costo_singolo': 0,
          'costo_totale': 0,
        }
      }
      console.log("Apertura dialogB");

      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogBClose() {
      console.log("Chiusura dialogB");
      this.dialogB.tabAdialogBIndex = 0;
    },
    async dialogBOk() {
      let error = false
      console.log("Cliccato bottone OK di dialogB");
      const elemento = this.elementiOrdineActiveData
      // elemento "nuovo" = aperto col pulsante NEW (non ancora presente nella grid)
      const isNuovo = this.elementiOrdineActiveId === 0

      if (elemento.id) {
        // elemento già salvato lato server → PATCH
        console.log("edit elemento")
        const editUrl = `${apiElementiOrdineUrl}/${elemento.id}`;
        error = await useJwt.patch(editUrl, elemento)
            .then((res) => {
              if (res.status == 200 || res.status == 201) {
                this.makeToast(
                  "primary",
                  "Successo",
                  "Modifica di un elemento ordine"
                );
              }

              const i = this.elementiOrdineFullData.findIndex((x) => x.id === elemento.id)
              if (i >= 0) {
                this.elementiOrdineFullData[i] = res.data
                this.elementiOrdineFullData = [...this.elementiOrdineFullData]
              }
              return false
            })
            .catch(err => {
              let messaggio = ""
              if (err.response) {
                let chiavi = Object.keys(err.response.data)
                chiavi.forEach((k) => {
                  messaggio += `${k}: ${err.response.data[k]}`
                  messaggio += "\n"
                })
                console.log(messaggio)
                this.makeToast("primary", "ERRORE", messaggio);
              }
              return true
            })
      } else if (this.ordiniActiveId != 0) {
        // elemento senza id ma ordine già salvato → creo singolo elemento lato server.
        // Vale sia per un nuovo elemento sia per uno scartato dal bulk_create perché non valido.
        console.log("crea singolo elemento")
        const datiDaInviare = {
          'ordine_id': this.ordiniActiveId,
          'elemento': elemento,
        }
        error = await useJwt.post(apiElementoOrdineCreateSingoloUrl, datiDaInviare)
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              console.log(res.data)
            }
            // assegno l'id restituito dal server all'elemento
            if (res.data && res.data.id) {
              elemento.id = res.data.id
            }
            // aggiungo alla grid solo se è un nuovo elemento (in edit è già presente)
            if (isNuovo) {
              this.elementiOrdineFullData.push(elemento)
            }
            this.elementiOrdineFullData = [...this.elementiOrdineFullData]
            return false
          })
          .catch(err => {
            let messaggio = ""
            if (err.response) {
              let chiavi = Object.keys(err.response.data)
              chiavi.forEach((k) => {
                messaggio += `${k}: ${err.response.data[k]}`
                messaggio += "\n"
              })
              console.log(messaggio)
              this.makeToast("primary", "ERRORE", messaggio);
            }
            return true
          })
      } else if (isNuovo) {
        // ordine non ancora salvato: aggiungo solo localmente, sarà inviato al salvataggio dell'ordine
        this.elementiOrdineFullData.push(elemento)
        this.elementiOrdineFullData = [...this.elementiOrdineFullData]
      }

      if (!error) {
        // nascondi dialog solo se salvataggio avvenuto con successo
        this.$refs.dialogB.hide();
      }
    },
    dialogBCancel() {
      console.log("Cliccato bottone Cancel di dialogB");
      this.$refs.dialogB.hide();
    },
    gridDClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "new") {
        // nuovo elemento
        this.elementiOrdineActiveId = 0
        this.$refs.dialogB.show(true);
      } else if (args.item.id === "edit") {
        // edit
        try {
          const selectedRow = this.$refs.gridD.getSelectedRecords()
          // uso direttamente il record selezionato come riferimento: gli elementi
          // scartati dal bulk_create restano in grid senza id e findIndex per id
          // non li troverebbe
          this.elementiOrdineActiveData = selectedRow[0]
          this.elementiOrdineActiveId = selectedRow[0].id
          console.log(this.elementiOrdineActiveId)
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella")
          this.alertAShow()
        }
        this.$refs.dialogB.show(true);
      } else if (args.item.id === "delete") {
        // Pulsante DELETE
        // cancella elemento ordine
        try {
          console.log("Premuto pulsante elimina di gridD");
          this.$refs.gridD.ej2Instances.deleteRecord();

          const selectedRow = this.$refs.gridD.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;
            console.log("elimino elemento ordine")
            console.log(selectedRow[0])
            console.log(deletedElementId)
            if (deletedElementId) {
                const deleteUrl = `${apiElementiOrdineUrl}/${deletedElementId}`;
                this.$refs.gridA.ej2Instances.deleteRecord();

                useJwt.delete(deleteUrl).then((res) => {
                    console.log("Eliminazione avvenuta con successo");
                    // console.log(res.data)
                });
            } else {
                console.log("elimino elemento non ancora salvato")
            }
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// seleziono il colore per evidenziare la riga selezionata
.e-grid td.e-active {
  background-color: #e5cbdd;
}
</style>
